import { InfoOutlined } from "@mui/icons-material";
import { Stack, Tooltip, Typography } from "@mui/material";
import { createContext, ReactNode, useContext } from "react";
import { FlussValidationError } from "modules/fluss/types/fluss";

const InlineIssues = createContext<FlussValidationError[]>([]);
const FieldPath = createContext("");
export const useFlussInlineIssues = () => useContext(InlineIssues);
export const useFlussFieldPath = () => useContext(FieldPath);

export const FlussInlineIssuesProvider = ({ issues, children }: { issues: FlussValidationError[]; children: ReactNode }) => (
    <InlineIssues.Provider value={issues}>{children}</InlineIssues.Provider>
);

export const FlussNodePanelField = ({
    label,
    children,
    hint,
    tooltip,
    fieldPath,
    issuePrefix = false,
    elementId,
}: {
    label: ReactNode;
    children: ReactNode;
    hint?: ReactNode;
    tooltip?: ReactNode;
    fieldPath?: string;
    issuePrefix?: boolean;
    elementId?: string;
}) => {
    const allIssues = useFlussInlineIssues();
    const issues = allIssues.filter((issue) => (!elementId || issue.element_id === elementId) && fieldPath && (
        issue.field === fieldPath || issue.field === `config.${fieldPath}` ||
        (issuePrefix && (issue.field?.startsWith(`${fieldPath}.`) || issue.field?.startsWith(`config.${fieldPath}.`)))
    ));
    return (
    <FieldPath.Provider value={fieldPath || ""}>
    <Stack spacing={0.75}>
        <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography
                component="label"
                variant="caption"
                color="text.secondary"
                sx={{ fontSize: 12, lineHeight: 1.25 }}
            >
                {label}
            </Typography>
            {tooltip && (
                <Tooltip title={tooltip} placement="top" arrow>
                    <InfoOutlined sx={{ fontSize: 14, color: "text.secondary", cursor: "help" }} />
                </Tooltip>
            )}
        </Stack>
        {children}
        {issues.map((issue, index) => (
            <Typography key={`${issue.code}-${index}`} variant="caption" color="error" role="alert">
                {issue.message}
            </Typography>
        ))}
        {hint && (
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: 12 }}>
                {hint}
            </Typography>
        )}
    </Stack>
    </FieldPath.Provider>
    );
};

export default FlussNodePanelField;
